
import { useIntl } from "../services/i18n";

export function getIbanOptions() {
  
  const intl = useIntl();
  return {
    mask: "ES00 0000 0000 0000 0000 0000",
    maskChar: "_",
    maskInvalidMessage: intl.i18n.t('validacion.iban_patron'),
    inputAttr: { class: 'uppercase-text'}
  };
}

export function getIbanPattern():RegExp {
    return /^ES\d{22}$/;
}

export function getDenoFacturaPattern():RegExp {
  return /^[A-Za-zÑñáéíóúüÁÉÍÓÚÜ0-9]{1,7}$/;
}